<template>
  <validation-observer
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="pay-insurance-monthly"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <form-row
        label="Do you normally pay for your insurance monthly?"
        :help-text="[
          'Paying via monthly instalments allows you to spread the cost over the year, but you may end up paying more in total.',
          'Paying annually may mean you pay less overall for the policy by avoiding any credit fees.',
        ]"
        :error="formObserver.validated && !observer.valid"
      >
        <validation-provider
          v-slot="{ failed }"
          :vid="`${stepId}_pay-insurance-monthly`"
          name="Pay Insurance Monthly"
          rules="required"
        >
          <radio
            v-model="questionData.payInsuranceMonthly"
            :data-test="snakeCase(questionFields.payInsuranceMonthly)"
            :name="`${stepId}.pay-insurance-monthly`"
            :items="constants.YES_NO"
            :error="failed"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';

export default {
  name: 'question-pay-insurance-monthly',
  extends: QuestionBase,
  data () {
    return {
      fields: ['payInsuranceMonthly'],
    };
  },
};
</script>
